export const addEventToMediaQuery = (
  listener: (event: MediaQueryListEvent) => void,
  mediaQueryList: MediaQueryList,
) => {
  if (mediaQueryList.addEventListener) {
    mediaQueryList.addEventListener('change', listener);
  } else {
    mediaQueryList.addListener(listener);
  }
};

export const removeEventFromMediaQuery = (
  listener: (event: MediaQueryListEvent) => void,
  mediaQueryList: MediaQueryList,
) => {
  if (mediaQueryList.addEventListener) {
    mediaQueryList.removeEventListener('change', listener);
  } else {
    mediaQueryList.removeListener(listener);
  }
};
